import { State } from '../reducers/types'

export const getShowSandboxUsBankBanner = (state: State): boolean =>
  state.payment.showSandboxUsBankBanner
